// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const RetrieveAllMapList = gql`
    query ExecuteRetrieveALLMapList(
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
    ) {
        executeRetrieveState(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            State
        }
        executeRetrieveLocationType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            LocationType
        }
        executeRetrieveInvestmentTier(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            InvestmentTier
        }
        executeRetrieveCommonwealthFunded(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            CommonwealthFunding
        }
        executeRetrievePipeline(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            InfraFlag
        }
        executeRetrieveProjectPhase(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PhaseType
        }
        executeRetrieveSuperSector(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            SuperSector
        }
        executeRetrieveMasterType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            MasterType
        }
        executeRetrieveProjectType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            RawProjectType
        }
        executeRetrieveLvl1Group(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
            Lvl1Group
        }
         executeRetrievePLEMGroup(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
        }
        executeRetrieveResourceGroup(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
            ResourceGroup
        }
    }
`;

export const RetrieveFiscalYears = gql`    
    query ExecuteRetrieveFiscalYears ()
    {
        executeRetrieveFiscalYears() {
            Type
            Min
            Max
        }
    }
`;

export const RetrieveStateSA4MapInvestment = gql`
    query ExecuteRetrieveStateSA4MapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveStateSA4MapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            State
            LocationType
            Value
        }
    }
`;

export const RetrieveSA4OverTimeMapInvestment = gql`
    query ExecuteRetrieveSA4OverTimeMapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
    ) {
        executeRetrieveSA4OverTimeMapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            LocationType
            Total_Prev
            Total_Next
        }
    }
`;

export const RetrieveSA4PerCapitaMapInvestment = gql`
    query ExecuteRetrieveSA4PerCapitaMapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inCalendarYear: Int
    ) {
        executeRetrieveSA4PerCapitaMapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inCalendarYear: $inCalendarYear
        ) {
            LocationType
            Value
            Population
        }
    }
`;

export const RetrieveStateSA4SuperSectorInvestment = gql`
    query ExecuteRetrieveStateSA4SuperSectorInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveStateSA4SuperSectorInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            State
            LocationType
            SuperSector
            Value
            Year
        }
    }
`;

export const RetrieveLabourSupplyDemand = gql`
    query ExecuteRetrieveLabourSupplyDemand (
        $inState: String
        $inLocationType: String
	    $inLvl1Group: String
	    $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveLabourSupplyDemand (
            inState: $inState
            inLocationType: $inLocationType
	        inLvl1Group: $inLvl1Group
	        inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            ObservationDate
            Demand
            Supply
            Difference
        }
    }
`;

export const RetrieveLabourOccupation = gql`
    query ExecuteRetrieveLabourOccupation (
        $inState: String
        $inLocationType: String
        $inLvl1Group: String
	    $inResourceGroup: String
        $inYear: Int
        $inMonth: Int
    ) {
        executeRetrieveLabourOccupation (
            inState: $inState
            inLocationType: $inLocationType
            inLvl1Group: $inLvl1Group
	        inResourceGroup: $inResourceGroup
            inYear: $inYear
            inMonth: $inMonth
        ) {
            Lvl1Group
            ResourceGroup
            Demand
            Supply
            Difference
        }
    }
`;

export const RetrieveNonLabourValueTonnage = gql`
    query ExecuteRetrieveNonLabourValueTonnage (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveNonLabourValueTonnage (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            PLEMGroup
            ResourceGroup
            Value
            Unit
            Year
        }
    }
`;